module.exports = __webpack_public_path__ + "img/infinity8ex_bg.08a73714.png";